import { IAppointmentScheduleResponse } from "@curefit/care-common";
import { isEmpty as _isEmpty } from "lodash";
import * as ActionTypes from "./ActionTypes";
import { ApiManager } from "../api/ApiManager";
import AppointmentScheduleRequestParamsBuilder from "../builder/AppointmentScheduleRequestParamsBuilder"
import { AppConstants, AppointmentScheduleTypeFlag, sortOrder } from "../utils/AppConstants"
import { IConsultationUpdateParams } from "../models/appointment/IConsultationUpdateParams"
import { AppointmentTypeFlagMap } from "../models/appointment/AppointmentTypeFlag";

export class AppointmentsActions {

    static fetchDoctorAppointmentsSuccess(appointment: IAppointmentScheduleResponse[]) {
        return { type: ActionTypes.FETCH_DOCTOR_APPOINTMENTS_SUCCESS, appointments: appointment };
    }

    static fetchAllDoctorAppointmentsSuccess(appointment: IAppointmentScheduleResponse[]) {
        return { type: ActionTypes.FETCH_ALL_DOCTOR_APPOINTMENTS_SUCCESS, appointments: appointment };
    }

    static fetchAppointmentsForPatientSuccess(appointments: IAppointmentScheduleResponse[]) {
        return { type: ActionTypes.FETCH_APPOINTMENTS_FOR_PATIENT_SUCCESS, appointments }
    }

    static fetchCenterAppointmentsSuccess(appointments: IAppointmentScheduleResponse[]) {
        return { type: ActionTypes.FETCH_CENTER_APPOINTMENTS_SUCCESS, appointments }
    }

    static updateAppointmentSuccess(appointment: IAppointmentScheduleResponse) {
        return { type: ActionTypes.UPDATE_APPOINTMENT_SUCCESS, appointment }
    }

    static fetchDoctorAppointment(dispatch: any, doctorId: number, startTimeEpoch: number, numOfDays: number,
        isForPoll?: boolean, tillTimeEpoch?: number, isPackInfoRequired?: boolean) {
        let reqBuilder: AppointmentScheduleRequestParamsBuilder = new AppointmentScheduleRequestParamsBuilder();
        if (!isForPoll) {
            reqBuilder
                .setDoctorId(doctorId)
                .setNumOfDays(numOfDays)
                .setStartTimeEpoch(startTimeEpoch)
                .setPatientRequired()
                .setRoomRequired()
                .setTeleconsultationRequired()
                .setConsultationProductRequired()
                .setBookingRequired()
                .setRootBookingRequired()
                .setIsAvailableDoctorActionRequired()
                .setPageSize(AppConstants.MAX_CONSULTATIONS_FETCH_COUNT)
                .setPackInfoRequired(isPackInfoRequired);
        } else {
            reqBuilder
                .setDoctorId(doctorId)
                .setStartTimeEpoch(startTimeEpoch)
                .setPatientRequired()
                .setTeleconsultationRequired()
                .setTillTimeEpoch(tillTimeEpoch)
                .setPageSize(1)  // we only need once cons to show the notification
                .setPackInfoRequired(isPackInfoRequired);
        }
        if (isForPoll) {
            return ApiManager.getAlbusApis().getAppointments(reqBuilder.build());
        }
        return ApiManager.getAlbusApis().getAppointments(reqBuilder.build()).then(appointmentSchedules => {
            dispatch(AppointmentsActions.fetchDoctorAppointmentsSuccess(appointmentSchedules));
        }).catch(error => {
            throw (error);
        });
    };

    static fetchAllDoctorAppointment(dispatch: any, doctorId: number) {
        let reqBuilder: AppointmentScheduleRequestParamsBuilder = new AppointmentScheduleRequestParamsBuilder();
        reqBuilder.setDoctorId(doctorId).setAppointmentContextRequired();
        return ApiManager.getAlbusApis().getAppointments(reqBuilder.build()).then(appointmentSchedules => {
            dispatch(AppointmentsActions.fetchAllDoctorAppointmentsSuccess(appointmentSchedules));
        }).catch(error => {
            throw (error);
        });
    };

    static fetchAppointmentsForPatient(dispatch: any, patientId: number, ) {
        let reqBuilder: AppointmentScheduleRequestParamsBuilder = new AppointmentScheduleRequestParamsBuilder();
        reqBuilder
            .setPatientId(patientId)
            .setPatientRequired()
            .setDoctorRequired()
            .setPatientExaminationsRequired()
            .setTeleconsultationRequired()
            .setConsultationProductRequired()
            .setMentalStatusRequired()
            .setSortOrder(sortOrder.DESCENDING)
            .setIsAvailableDoctorActionRequired()
            .setAppointmentContextRequired()
            .setSortBy("STARTTIME");
        return ApiManager.getAlbusApis().getAppointments(reqBuilder.build()).then(appointmentSchedules => {
            dispatch(AppointmentsActions.fetchAppointmentsForPatientSuccess(appointmentSchedules));
        }).catch(error => {
            throw (error);
        });
    };

    static fetchCenterAppointments(dispatch: any, centerId: number, startTime: number, numberOfDays: number, isPackInfoRequired?: boolean) {
        let reqBuilder: AppointmentScheduleRequestParamsBuilder = new AppointmentScheduleRequestParamsBuilder();
        reqBuilder.setCenterId(centerId).setStartTimeEpoch(startTime).setNumOfDays(numberOfDays).setRoomRequired().setDoctorRequired().setConsultationTypeRequired().setPatientRequired().setPackInfoRequired(isPackInfoRequired);
        return ApiManager.getAlbusApis().getAppointments(reqBuilder.build()).then(appointmentSchedules => {
            dispatch(AppointmentsActions.fetchCenterAppointmentsSuccess(appointmentSchedules))
        }).catch(error => {
            throw (error);
        });
    }

    static updateAppointment(dispatch: any, bookingId: number, appointmentId: number, consultationUpdateParams: IConsultationUpdateParams) {
        return ApiManager.getAlbusApis().updateAppointment(bookingId, appointmentId, consultationUpdateParams);
    }

    static fetchPaginatedDoctorAppointments(dispatch: any, doctorId: number, pageNo: number, pageSize: number, appointmentTypeFlags?: AppointmentTypeFlagMap, fromTimeEpoch?: number) {
        let reqBuilder: AppointmentScheduleRequestParamsBuilder = new AppointmentScheduleRequestParamsBuilder();
        if (!_isEmpty(appointmentTypeFlags)) {
            if (appointmentTypeFlags.showCompletedConsultationInMovingWindow) reqBuilder.setCompletedConsultationInMovingWindow()
            else if (appointmentTypeFlags.showOngoingConsultationInMovingWindow) reqBuilder.setOngoingConsultationInMovingWindow()
            else if (appointmentTypeFlags.showUpcomingConsultation) reqBuilder.setUpcomingConsultation()
        }
        if (fromTimeEpoch) reqBuilder.setStartTimeEpoch(fromTimeEpoch)
        reqBuilder
            .setDoctorId(doctorId)
            .setPatientRequired()
            .setAppointmentContextRequired()
            .setSortOrder(sortOrder.DESCENDING)
            .setSortBy("STARTTIME")
            .setPageNo(pageNo)
            .setPageSize(pageSize)
        return ApiManager.getAlbusApis().getAppointments(reqBuilder.build())
    }
}
